<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Generated Document</h1>
            <hr>
            <mdb-tbl responsive striped>
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Name</th>
                    <th>Type</th>
                    <!-- <th>Document</th> -->
                    <th>DateTime</th>
                    <th>Admin</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr v-for="(document, index) in documents" :key="document.id">
                    <td>{{index+1}}</td>
                    <td>
                        <a class="link" :href="getDocumentPath(document.path)">{{document.name}}</a>
                    </td>
                    <td>{{document.type}}</td>
                    <!-- <td>{{document.path}}</td> -->
                    <td>{{momentFormatDate16(document.created_at)}}</td>
                    <td>{{document.admin.name}}</td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer,mdbTbl, mdbTblHead, mdbTblBody} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {APP_STORAGE_URL} from '../js/config';
import {momentFormatDate16} from '../js/helper';
import scroll from '../js/infinityScroll';

export default {
    name: 'generated_document',
    components: {
        mdbContainer,mdbTbl, mdbTblHead, mdbTblBody,
        AppNavigation,
    },
    data: ()=>({
        loading: false,
        documents: []
    }),
    methods: {
        getData(){
            if(this.loading){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/get_generated_documents",
                data: {
                    id: this.documents.length==0?null:this.documents[this.documents.length-1].id
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    let _temp=[...this.documents];
                    this.documents=_temp.concat(result.data);
                },
            }, this)
        },
        momentFormatDate16(date){
          return momentFormatDate16(date);
        },
        getDocumentPath(path){
            return APP_STORAGE_URL+path;
        }
    },
    mounted: function(){
        this.getData();
        scroll(()=>this.getData());
    }
}
</script>

<style scoped>
.link{
    color: #2196f3;
    cursor: pointer;
}
.link:hover{
    color: #0D47A1;
}
</style>
